/**
 * author       : zwl
 * createTime   : 2019/5/27 4:19 PM
 * description  : 远程请求地点
 */
import AMap from 'AMap'
import axios from 'axios'
var instance = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export function _queryMapSuggestion (queryString) {
  let suggestionArr = []
  let url = '//restapi.amap.com/v3/config/district?keywords=' + queryString + '&subdistrict=0&key=69674879fdcf0d22a67deda555e2ef3b'
  instance.get(url).then((data) => {
    if (data.data.districts.length > 0) {
      data.data.districts.map(function (item) {
        if (item.level.trim() !== 'street') {
          suggestionArr.push({value: queryString, address: item.name, adcode: item.adcode})
          return suggestionArr
        }
      })
    }
    if (suggestionArr.length < 1) {
      let placesearch = new AMap.Autocomplete({
        city: '',
        datatype: 'poi'
      })
      placesearch.search(queryString, function (status, result) {
        if (status.trim() === 'complete' && result.tips.length > 0) {
          var m = new Map()
          result.tips.map(function (item) {
            if (m.get(item.adcode) == null) {
              var arrs = item.district + '$' + item.name
              m.set(item.adcode, arrs.split('$'))
            }
          })
          m.forEach(function (value, key, map) {
            suggestionArr.push({value: queryString, address: value[0], adcode: key})
          })
          return suggestionArr
        } else {
          // eslint-disable-next-line
          suggestionArr.push({value: queryString, address: '没有找到指定地区，请选择地区', adcode: ''})
          return suggestionArr
        }
      })
    }
  })
  return suggestionArr
}
